import { render, staticRenderFns } from "./ReceiptPreCheckInfoViewer.vue?vue&type=template&id=05608dde&scoped=true&"
import script from "./ReceiptPreCheckInfoViewer.vue?vue&type=script&lang=ts&"
export * from "./ReceiptPreCheckInfoViewer.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptPreCheckInfoViewer.vue?vue&type=style&index=0&id=05608dde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05608dde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
